/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import { HOC } from 'formsy-react';

// no protect
export default class CustomCheckbox extends Component {
    changeValue(event) {
        if (this.props.setValue) {
            this.props.setValue(event.target.checked);
        }

        this.props.handleChange({
            target: {
                name: this.props.name,
                value: event.target.checked,
            },
        });
    }

    render() {
        let labelContent;
        if (this.props.allowLabelHtml) {
            labelContent = <span dangerouslySetInnerHTML={{ __html: this.props.label }}></span>;
        } else {
            labelContent = this.props.label;
        }

        const className = this.props.className ? this.props.className : 'app__custom-checkbox';

        return <div className={ `${className}` }>
            <label className={ `${className}__input` }>
                <input type="checkbox"
                       name={ this.props.name }
                       onChange={ this.changeValue.bind(this)}
                       checked={this.props.value}
                />
                { labelContent }
            </label>
        </div>;
    }
}

CustomCheckbox.propTypes = {
    label: React.PropTypes.string,
    name: React.PropTypes.string,
    value: React.PropTypes.node,
    className: React.PropTypes.string,
    allowLabelHtml: React.PropTypes.bool,
    handleChange: React.PropTypes.func,
};

export const FormCustomCheckbox = HOC(CustomCheckbox);



// WEBPACK FOOTER //
// ./src/components/elements/CustomCheckbox.jsx